'use client';

import {useContext} from 'react';

import {InputComponent} from 'Input';
import {SelectContext} from 'Select/Select';

import type {InputInputComponent} from 'Input';

export const NoWrapInput: InputInputComponent = props => {
  const isReadOnly = !useContext(SelectContext).filter;

  const inputProps = {
    ...props,

    inputProps: {...props.inputProps, readOnly: isReadOnly},

    style: {...props.style, isReadOnly},
  };

  return <InputComponent {...inputProps} />;
};
